
import { defineComponent, computed, toRefs, PropType } from "vue";
import AdmIcon from "../Icon";
import "./button.scss";
import { useId } from "../hooks/identifier";

export default defineComponent({
  name: "adm-button",
  inheritAttrs: false,
  components: {
    AdmIcon,
  },
  props: {
    id: {
      type: String,
      default: "",
      required: true,
    },
    forceId: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    variant: {
      type: String as PropType<"contained" | "outlined" | "text">,
      default: "contained",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    leadingIcon: {
      type: String,
      default: null,
    },
    trailingIcon: {
      type: String,
      default: null,
    },
  },
  emits: ["click"],
  setup(props, { emit }) {
    const {
      color,
      disabled,
      fullWidth,
      href,
      variant,
      leadingIcon,
      trailingIcon,
    } = toRefs(props);
    const identifier = useId(props, "adm-button");

    const classes = computed(() => [
      "adm-button",
      `adm-button--color-${color.value}`,
      {
        "adm-button--outlined": variant.value === "outlined",
        "adm-button--text": variant.value === "text",
        "adm-button--full-width": fullWidth.value,
        "adm-button--disabled": disabled.value,
        "adm-button--icon": leadingIcon.value || trailingIcon.value,
      },
    ]);
    const tag = computed(() => (href.value ? "a" : "button"));

    const onClick = ($event: Event) => {
      emit("click", $event);
    };

    return {
      classes,
      tag,
      identifier,
      onClick,
    };
  },
});
